const alertType = {
  SHOW_ALERT: "SHOW_ALERT",
  CLOSE_ALERT: "CLOSE_ALERT",
  SHOW_SUCCESS_ALERT: "SHOW_SUCCESS_ALLERT",
  SHOW_DANGER_ALERT: "SHOW_DANGER_ALERT",
  SHOW_INFO_ALERT: "SHOW_INFO_ALERT",
  SHOW_START_SIM_ALERT: "SHOW_START_SIM_ALERT",
  SHOW_MODAL: "SHOW_MODAL",
};

export default alertType;
